import React, { Fragment, useState } from "react";
import { Card, Col, Modal, Row } from "antd";
import Modal_v2 from "../../stories/components/Modal_v2";
import { TickIcon } from "../../common/CustomIcon";

const OrderItemDetails = ({
  isFilled,
  currentOrder,
  location,
  type,
  ResponseComponent,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => setIsModalVisible(false);

  const renderFormModal = () => {
    return (
      <Modal
        visible={isModalVisible}
        onCancel={(e) => {
          e.stopPropagation();
          handleCancel();
        }}
        title={`${type} Details`}
        mask={true}
        maskClosable={false}
        closable={true}
        footer={null}
        width={1000}
        style={{ top: 40, overflowY: "auto" }}
      >
        {type === "Form" ? (
          <ResponseComponent
            recordId={currentOrder.id}
            locationId={location?.id || ''}
          />
        ) : (
          <ResponseComponent
            surveyId={currentOrder.id}
            surveyLocationId={location?.id || ""}
          />
        )}
      </Modal>
    );
  };

  return (
    <Fragment>
      <Card
        onClick={isFilled === true ? showModal : null}
        style={{
          border: isFilled === true ? "1px solid #E6EBF0" : "none",
          backgroundColor: isFilled === true ? "" : "#F7F8FA",
          borderRadius: "4px",
          padding: 16,
          minWidth: 196,
          // cursor: "pointer",
        }}
        bodyStyle={{ padding: 0 }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span
            style={{
              color: "#111314",
              fontFamily: "Lato",
              fontSize: "16px",
              fontWeight: 700,
            }}
          >
            {type === "Form" ? "Form" : "Survey"}
          </span>
          {isFilled === true ? (
            <span
              style={{
                borderRadius: "32px",
                backgroundColor: "#D0F4E7",
                padding: "4px 8px",
                color: "#0F8D60",
                fontFamily: "Lato",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Complete{" "}
              <TickIcon
                height="14"
                width="14"
                color="#0F8D60"
                style={{ marginLeft: "2px" }}
              />
            </span>
          ) : (
            <span
              style={{
                borderRadius: "32px",
                backgroundColor: "#E6EBF0",
                padding: "4px 8px",
                color: "#33393D",
                fontFamily: "Lato",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "default",
              }}
            >
              Pending
            </span>
          )}
        </div>
      </Card>
      {renderFormModal()}
    </Fragment>
  );
};

export default OrderItemDetails;
